"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSubsocialAddress = void 0;
const util_crypto_1 = require("@polkadot/util-crypto");
const toSubsocialAddress = (address) => {
    if (!address || !(0, util_crypto_1.isAddress)(address))
        return undefined;
    return (0, util_crypto_1.encodeAddress)((0, util_crypto_1.decodeAddress)(address), 28);
};
exports.toSubsocialAddress = toSubsocialAddress;
